<template>
  <div v-if="lat && lng">
    <h2 id="pickupPoint" class="mb-3">{{ t('pickupPoint') }}</h2>

    <GMapWithMarker :api-key="apiKey" :lat="lat" :lng="lng" :zoom="18" :marker-title="address" />

    <div v-if="servicePoint">
      <br />
      <h4>{{ displayAddress }}</h4>
    </div>
    <hr class="tracking-divider" />
  </div>
</template>

<script lang="ts">
import type { PickupPoint, ServicePoint, TrackingData } from '@/types/Models/Shipment'
import { defineComponent, computed, type ComputedRef, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { uniqueStrings } from '@/helpers/Utils'
import GMapWithMarker from '@/views/Components/GMapWithMarker.vue'

export default defineComponent({
  name: 'AddressMap',
  components: {
    GMapWithMarker,
  },
  props: {
    point: {
      type: Object as PropType<PickupPoint>,
      required: true,
    },
    itemData: {
      type: Object as PropType<TrackingData>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const lat: ComputedRef<number> = computed(() => props.point.latitude || 0)
    const lng: ComputedRef<number> = computed(() => props.point.longitude || 0)
    const address: ComputedRef<string> = computed(() => props.point.address || `${lat.value}, ${lng.value}`)
    const servicePoint: ComputedRef<ServicePoint | null> = computed(() => props.itemData.servicePoints[0] || null)

    const displayAddress: ComputedRef<string> = computed(() =>
      uniqueStrings([
        servicePoint.value?.name,
        servicePoint.value?.countryCode,
        servicePoint.value?.postalCode,
        servicePoint.value?.city,
        servicePoint.value?.addressLine,
      ]).join(', '),
    )

    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''

    return {
      lng,
      lat,
      apiKey,
      address,
      servicePoint,
      displayAddress,
      t,
    }
  },
})
</script>
